import { render, staticRenderFns } from "./ShareToTeamForEdit.vue?vue&type=template&id=54294416&scoped=true&"
import script from "./ShareToTeamForEdit.vue?vue&type=script&lang=js&"
export * from "./ShareToTeamForEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShareToTeamForEdit.vue?vue&type=style&index=0&id=54294416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54294416",
  null
  
)

export default component.exports